import { html } from 'lit-element';

/*
 * create html template result with tag and params
 * */
export default function d(tag, attrs = {}, events = {}) {
  // Note: all attr will convert to string
  if (!/^[\w-]+$/.test(tag)) {
    throw new Error(`invalid element tag: ${tag}`);
  }
  const keys = Object.keys(attrs || {});
  const attrNames = keys.map(k => ` .${k}=`);
  const attrVals = keys.map(k => attrs[k]); // TODO to string ?

  const eventKeys = Object.keys(events || {});
  const eventNames = eventKeys.map(k => ` @${k}=`);
  const eventHandlers = eventKeys.map(k => events[k]);

  return html(
    [`<${tag} dt=`, ...attrNames, ...eventNames, `></${tag}>`],
    ' ',
    ...attrVals,
    ...eventHandlers,
  ); // TODO 'dt' just a temp solution
}
